var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35569",
    "data-name": "Group 35569",
    transform: "translate(-65 -473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27153",
    "data-name": "Group 27153",
    transform: "translate(65 473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    d: "M14,2.1A11.9,11.9,0,0,0,5.585,22.415,11.9,11.9,0,0,0,22.415,5.585,11.822,11.822,0,0,0,14,2.1M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(0)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39511",
    "data-name": "Path 39511",
    d: "M.49,0V-1.1L3.45-4.03a1.725,1.725,0,0,0,.27-.315,1.292,1.292,0,0,0,.15-.315,1.068,1.068,0,0,0,.05-.32.684.684,0,0,0-.295-.565A1.177,1.177,0,0,0,2.89-5.77a2.023,2.023,0,0,0-.88.2,3.448,3.448,0,0,0-.89.665L.26-5.96a4.345,4.345,0,0,1,1.275-.86,3.524,3.524,0,0,1,1.4-.29,3.1,3.1,0,0,1,1.3.255,2.057,2.057,0,0,1,.865.71A1.845,1.845,0,0,1,5.42-5.08a2.123,2.123,0,0,1-.095.635,2.2,2.2,0,0,1-.3.6,4.058,4.058,0,0,1-.52.6L2.49-1.3l3.03-.01V0Z",
    transform: "translate(76.11 490.556)",
    fill: "#1c1c1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.6cee0b4dc3ad9221ff85472e778e596e.svg";
export { ForwardRef as ReactComponent };